<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 19:38:16
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-11-09 15:19:12
 * @name: 添加子部门
 * @Description: 添加子部门
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\dialog\add-department.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog
    ref="addNeditDialog"
    title="添加部门"
    bar-title="部门信息"
    @close="close"
  >
    <template v-slot:form>
      <div class="line">
        <font class="label"><i class="warn">*</i>部门名称:</font>
        <el-input
          class="input"
          v-model="department_name"
          placeholder="请输入部门名称"
        ></el-input>
      </div>
      <div class="line">
        <font class="label">上级部门:</font>
        <el-select class="input" v-model="parent_id">
          <el-option
            v-for="item of parents"
            :key="item.id"
            :label="item.department_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="save">保存</el-button>
      <el-button plain @click="cancel">取消</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { confirmation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog";
export default {
  name: "mailList-Content-addDepartment",
  components: {
    addNeditDialog,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      department_name: "", //部门名称
      parent_id: "", //上级id
      parents: [], //上级部门列表
    };
  },
  computed: {
    // 验证部门是否已填
    department_name_match() {
      return this.department_name === "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开dialog
     */
    open() {
      let { all, me } = this.mailList.getAllNodeNnow();
      this.parents = all;
      this.parent_id = me;
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击保存
     */
    @confirmation("确认添加?")
    save() {
      let params = {
        name: this.department_name,
        parent_id: this.parent_id ?? 0,
      };
      this.mailList.addItem(params).then((res) => {
        this.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击取消
     */
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化
     */
    close() {
      this.department_name = "";
      this.parent_id = "";
      this.parents = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 400px;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>
